var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-container"},[_c('div',[_c('div',{staticClass:"h1"},[_vm._v(" WELCOME "+_vm._s(_vm.username)+" TO")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h1"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/img/newerp_icon3.png"),"alt":""}}),_vm._v("全球青少年PBL创新素养大会")])
}]

export { render, staticRenderFns }